import PDF from "../website-behaviors/PDF.js";
import ProQuestCongressional from "./ProQuestCongressional.js";

class ProQuestCongressionalPdf extends PDF {
	identifier() {
		return "ProQuestCongressionalPdf";
	}

	static test(location: Location) {
		return ProQuestCongressional.test(location);
	}

	async init(): Promise<void> {
		return ProQuestCongressional.prototype.init.call(this);
	}

	initMainWorld() {
		return ProQuestCongressional.prototype.initMainWorld.call(this);
	}

	async generateStructuredCitation() {
		return ProQuestCongressional.prototype.generateStructuredCitation.call(this);
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'processOrgProxy' implicitly has an 'any... Remove this comment to see the full error message
	getPageUrl(processOrgProxy, isClean = false): string {
		return ProQuestCongressional.prototype.getPageUrl.call(this, processOrgProxy, isClean);
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'processOrgProxy' implicitly has an 'any' type.
	// noinspection JSUnusedGlobalSymbols
	getProQuestCongressionalPageUrl(processOrgProxy): string | null {
		return ProQuestCongressional.prototype.getProQuestCongressionalPageUrl.call(this, processOrgProxy);
	}

	// noinspection JSUnusedGlobalSymbols
	getProQuestCongressionalPageTitle(): string | null {
		return ProQuestCongressional.prototype.getProQuestCongressionalPageTitle.call(this);
	}

	// noinspection JSUnusedGlobalSymbols
	getSingleRisValue(name: string): string | undefined {
		return ProQuestCongressional.prototype.getSingleRisValue.call(this, name);
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
	async mouseUp(event, bypassHighlightRules, isSelectionEqual, isPageCoordEqual, page, processOrgProxy): Promise<boolean> {
		return ProQuestCongressional.prototype.mouseUp.call(this, event, bypassHighlightRules, isSelectionEqual, isPageCoordEqual, page, processOrgProxy);
	}

	styles(): string | null {
		// The PDF viewer for ProQuest Congressional is a newer version of pdf.js than we use in pn-browser-ext, which
		// changed the opacity of .textLayer from 0.25 to 1.
		// See: https://github.com/mozilla/pdf.js/commit/83c78dbfa8f2f532b22ba10cebca2a67c0fac8ef#diff-90b9c7e02c41b4051095250577f8dd385455429d67abe6bf360e13ef17d7fe19R21

		// language=CSS
		return `
			.textLayer .aa-highlight {
				opacity: 0.3;
			}
		`;
	}
}

export default ProQuestCongressionalPdf;
